import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { session } from '../../../services/session';

import { linksService } from './links-service';

const CopyLinks = ({ selectedStory, oldLinks, setNewLinks }) => {
  const history = useHistory();

  useEffect(() => {
    const oldLinksList = linksService.parseLinks(oldLinks);
    createLinks(oldLinksList);
  }, []);

  async function createLinks(oldLinksList) {
    const params = {
      edit_id: selectedStory.edit_id,
      urls: oldLinksList,
    };

    const res = await linksService.createLinks(session.orgId, params);
    const data = res.data.data[0];

    const newLinkObjects = oldLinksList.map(link => data[link]);
    const newLinks = newLinkObjects.map(data => data.encoded_auction_url);

    setNewLinks(newLinks.join('\n\n'));

    history.push(`/v2/publisher/${session.orgId}/links/create-links/created-links`);
  }

  return (
    <div className="copy-links">
      <div className="loader">
        <div className="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div className="validating">Creating new product links...</div>
    </div>
  );
};

export default CopyLinks;
